export default "__VITE_ASSET__CCDd7JGb__"